module.exports = __webpack_public_path__ + "img/dropdown-icon.929f54698e175c8005e38947edf808fa.svg";